import React, { Component, PureComponent } from 'react'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label, Checkbox } from 'semantic-ui-react'
import { SubeditorArea } from '~/common/subeditor'

export default function InterviewNotes({ interview }) {
  return (
    <SubeditorArea title="Muistiinpanot">
      <div>Näytä muistiinpanot</div>
    </SubeditorArea>
  )
}
